var map = {
	"./2-1.jpg": 772,
	"./bgbig.jpg": 63119,
	"./drawers": 82780,
	"./drawers.ts": 82780,
	"./iphone_mock_clear.png": 8190,
	"./report.xlsx": 61831,
	"./servicechat.png": 13791,
	"./smscampaign.png": 60037,
	"./sun2.jpg": 66075,
	"./sunrise.jpg": 25001,
	"./whatsup.png": 69998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18136;